module.exports = __webpack_public_path__ + "static/img/hot_banner.d4139ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/hot_banner.jpg
// module id = fmB2
// module chunks = 0